// removed by extract-text-webpack-plugin
module.exports = {"container":"FullscreenIFrame__container__2EKTJ","popupBox":"FullscreenIFrame__popupBox__3nvob","titleRow":"FullscreenIFrame__titleRow__22a41","contentRow":"FullscreenIFrame__contentRow__IFdVf","btnRow":"FullscreenIFrame__btnRow__3i8bP","btn":"FullscreenIFrame__btn__1XwVl"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/FullscreenIFrame/FullscreenIFrame.css
// module id = 511
// module chunks = 0